module.exports = __webpack_public_path__ + "static/media/queen_of_spades.58d77ea5.svg";